module.exports = "<div class=\"round-button {{subtypeId}}-round-button\" *ngIf=\"elementType\" [class.activated]=\"selected\" >\n\n    <div id=\"{{elementType.id}}-circle\" [style.background-image]=\"url\" [style.background-color]=\"color\" class=\"circle-container\"></div>\n\n    <span *ngIf=\"elementType.label\">{{elementType.label[lang]}}</span>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/round-button/round-button.component.html
// module id = ./src/app/ui/round-button/round-button.component.html
// module chunks = main